<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN ParaOverride-1" id="_idParaDest-2"><span class="CharOverride-1">Also by Lily King</span></p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-2">Father of the Rain</span></p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-2">The English Teacher</span></p>
<p class="BT1stPara ParaOverride-2"><span class="CharOverride-2">The Pleasing Hour</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42761.vue?783eddd6